import React from 'react';
import { compose } from 'redux';
import FormList from '../../../../../../../components/form-list';
import CaseCondition from './CaseCondition';
import { Card, Col, Radio, Row } from 'antd';
import { getInitialCaseCondition } from '../../../utils';
import {  GUTTER_XS, MARGIN_MD, MARGIN_XS, SPAN_FULL } from '../../../../../../../styles/constants';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { onChangeCaseFunction } from '../../actions';
import SelectEditable from '../SelectEditable';


const mapDispatchToProps = dispatch => ({
    onChangeForm: (value) => dispatch(onChangeCaseFunction(value))
})

const CaseBlock = ({
    t,
    onChangeForm,
    value,
    selectFunction,
    selectComponent,
    selectOperators,
    nameValue
}) => {
    const conditionsIndex = (value.conditions || []).length
    const block = React.useMemo(()=> { return value},[value])
    const [baseValue, setBaseValue] = React.useState(null)

    React.useEffect(()=>{
        if(!!block.baseValue){
            setBaseValue(block.baseValue )
        }
    },[block])

    return (
        <Card>
            <Row style={{marginBottom:MARGIN_XS }}>
                <Col span={SPAN_FULL}>
                    <Radio.Group size="small" 
                    value={block.logicalOperator}
                    onChange={({target}) => onChangeForm({blockIdx: block.blockIdx, logicalOperator:target.value })}>      
                    {['AND', 'OR'].map(op =>
                        <Radio.Button key={op} value={op}>{op}</Radio.Button>)
                    }
                    </Radio.Group> 
                </Col>
            </Row>
            <Row type="flex" style={{ marginBottom: MARGIN_MD }} align='middle'>    
                <Col span={17}>
                    <FormList
                        compact
                        notCollapsable
                        values={value.conditions}
                        Component={CaseCondition}
                        componentProps={{
                            selectFunction:selectFunction,
                            selectComponent:selectComponent,
                            block:block,
                            conditionsIndex:conditionsIndex,
                            selectOperators:selectOperators
                        }}
                        newItem={getInitialCaseCondition(conditionsIndex)}
                        addItemLabel={t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.addCondition')}
                        removeItemLabel={t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.removeCondition')}
                        onChange={values => onChangeForm({blockIdx: block.blockIdx, conditions: values})}
                        /> 
                </Col >
                <Col span={7} style={{display:'flex', justifyContent:'center', alignItems:'center', marginBottom:50}}>
                    <Row type="flex" align='middle' style={{gap:GUTTER_XS, textTransform:'uppercase'}}>
                        <span>{!!nameValue ? `${nameValue}=` : t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.baseFor')}</span>
                        <SelectEditable 
                            width={130}
                            options={selectComponent}
                            value={baseValue}
                            onValue={(value) =>  onChangeForm({blockIdx: block.blockIdx, baseValue:value })}
                        />
                    </Row>
                </Col>
            </Row>
    </Card>
    )
}

export default compose(
    translate(),
    connect(null, mapDispatchToProps)
)(CaseBlock)